export const DATA_CY_DOCUMENT_LAYOUT = 'document-layout';